import development from "./development";
import type { AppConfig } from "./types";

const local: AppConfig = {
  ...development,
  enforceForthLeafAccess: true,
};

export default local;
